export default __webpack_public_path__ + "static/media/5303389.35075235.png";